(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-navigation"] && !Shopify.designMode) return;
  try {
    class CarouselNav extends HTMLElement {
    connectedCallback() {
      this.#mount();
      this.prevBtn = this.querySelector('.carousel-nav__btn--prev');
      this.nextBtn = this.querySelector('.carousel-nav__btn--next');

      if (this.dataset.bound === 'true') return;

      this.prevBtn?.addEventListener('click', () => this.#navigate('previous'));
      this.nextBtn?.addEventListener('click', () => this.#navigate('next'));
      this.dataset.bound = 'true';
    }

    #mount() {
      if (this.dataset.navPosition !== 'overlay' || this.dataset.mounted === 'true') return;

      const section = this.closest('.shopify-section');
      const slideshowContainer = section?.querySelector('slideshow-component > slideshow-container');
      if (!slideshowContainer) {
        requestAnimationFrame(() => this.#mount());
        return;
      }

      slideshowContainer.appendChild(this);
      this.dataset.mounted = 'true';
    }

    #navigate(direction) {
      const section = this.closest('.shopify-section');
      const slideshow = section?.querySelector('slideshow-component');
      if (!slideshow) return;
      if (direction === 'previous') {
        slideshow.previous?.();
      } else {
        slideshow.next?.();
      }
    }
  }

  if (!customElements.get('carousel-nav')) {
    customElements.define('carousel-nav', CarouselNav);
  }
  } catch(e) { console.error(e); }
})();

})();
